// extracted by mini-css-extract-plugin
export default {"af-navbar-brand":"af-navbar-brand_af-navbar-brand__ho2+b"};